<template>
  <footer class="st-content-footer">
    <p class="st-footer" v-markdown="footer"></p>
  </footer>
</template>
<script>
export default {
  data () {
    return {
      footer: null
    }
  },
  computed: {
    currentYear () {
      const d = new Date()
      return d.getFullYear()
    }
  },
  created () {
    const URL = `https://www.straitstimes.com/multimedia/graphics/assets/json/sph-footer.json`
    fetch(URL)
      .then(response => response.json())
      .then(data => {
        this.footer = data.footer
      })
      .catch(() => (
        this.footer = `Published by SPH Media Limited, Co. Regn. No. 202120748H. Copyright © ${this.currentYear} SPH Media Limited. All rights reserved.`
      ))
  }
}
</script>
<style lang="scss" >
.st-content-footer {
  background-color: #FFFFFF;
  text-align: center;
  // position: absolute;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #B4B4B4;

  .st-footer {
    padding: 15px;
    font-size: 13px;
    font-weight: normal;
    font-family: $font-CuratorRegular;
    color: #333333;
    margin-bottom: 0;
    line-height: 1.5;
    box-sizing: border-box;

    @include container;

    @include breakpoint($d_medium) {
      padding: 20px;
    }
  }
}

</style>
